module.exports = __webpack_public_path__ + "img/pertandingan.55928e67.png";